/** @jsxImportSource @emotion/react */
import * as organizationSelectors from "../organization/organizationSelectors";
import * as authSelectors from "../auth/authSelectors";
import { Link, useParams } from "react-router-dom";
import { routes } from "../../appRoutingHelpers";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { css } from "@emotion/react";
import { StyledText } from "../../assets/typography/typography";

const orgContainerStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

type Props = {
  organizationName?: string;
};

export const HeaderBrand = ({ organizationName }: Props) => {
  const { organization: organizationKeyName } = useParams<{
    organization: string;
  }>();
  const isSelectingOrganization = useSelector(
    authSelectors.isSelectingOrganization
  );
  const uiSettings = useSelector(organizationSelectors.currentUISettings);
  const logoSrc = uiSettings?.logoSrc;

  return (
    <Link to={routes.home(organizationKeyName)} className="header-brand">
      {isSelectingOrganization ? (
        <FontAwesomeIcon icon={solid("spinner")} spin pulse />
      ) : (
        <div css={orgContainerStyle}>
          {logoSrc && logoSrc.length > 0 && (
            <img
              src={logoSrc}
              className="header-brand-img"
              alt={`${organizationName} logo`}
            />
          )}
          <StyledText className="bodyHeaderOneSemi mb-0">
            {organizationName}{" "}
            <span className="bodyHeaderOneRegular mb-0">Admin</span>
          </StyledText>
        </div>
      )}
    </Link>
  );
};
